import { InputHTMLAttributes } from "react";
import {
  Control,
  Controller,
  FieldValues,
  Path,
  RegisterOptions,
} from "react-hook-form";
import { useTranslation } from "react-i18next";

interface InputTextProps<FieldsType extends FieldValues> {
  name: Path<FieldsType>;
  control: Control<FieldsType>;
  rules?: RegisterOptions<FieldsType>;
  inputProps?: InputHTMLAttributes<HTMLInputElement>;
  label?: string;
  required?: boolean;
  shouldUnregister?: boolean;
  requiredMessage?: string;
}

export default function EmailField<FieldsType extends FieldValues>({
  name,
  label,
  control,
  required,
  requiredMessage,
  shouldUnregister,
  rules,
  inputProps = {},
}: InputTextProps<FieldsType>) {
  const { t } = useTranslation();

  return (
    <Controller
      name={name}
      shouldUnregister={shouldUnregister}
      control={control}
      rules={{
        required: requiredMessage || (required && t("Required")),
        ...(rules || {}),
      }}
      render={({ field, fieldState: { error } }) => (
        <div className="relative">
          {label && (
            <label className="text-base ml-1 mb-0.5 block" htmlFor={field.name}>
              <span>
                {t(label)}
                {(required || requiredMessage) && (
                  <span className="text-red-600 ml-0.5 text-base">*</span>
                )}
              </span>
            </label>
          )}
          <input
            id={field.name}
            className="placeholder:text-gray-500 border-gray-200 rounded-lg w-full px-2.5 py-3 border focus:border-brand-hover
            focus-within:border-brand-hover focus:bg-[#eaf1fa]  transition-all focus:ring-0 focus-visible:ring-0 focus-visible:border-brand-hover outline-none"
            type="email"
            inputMode="email"
            placeholder="example@email.com"
            {...field}
            {...(inputProps || {})}
          />
          <p className="text-red-600 font-normal text-sm m-0 p-0 ml-1  bottom-0 left-0 right-0">
            {t(error?.message)}
          </p>
        </div>
      )}
    />
  );
}
